import type { StagedActionView } from './types'

/**
 * Stable empty collections for optional `StagedActionView` fields.
 *
 * Action cells re-render on every status-atom change, and a fresh `[]` per render
 * churns downstream deps — memoized tag transitions, the markdown preview's image
 * renderer. Share one reference instead of `?? []` at each call site.
 */
export const NO_ATTACHMENTS: NonNullable<StagedActionView['attachments']> = []
export const NO_NESTED_VIEWS: NonNullable<StagedActionView['nestedViews']> = []
